export default __webpack_public_path__ + "static/media/cliente11_color.e567ab91.png";